import { useMutation } from '@apollo/client/react';
import { Button, Form, Input, message, Space, Spin } from 'antd';
import React from 'react';
import { Email, LoginLogo } from '../../assets/svg/login';
import { ROUTES } from '../../common/constants';
import { formValidatorRules } from '../../common/utils';
import useRouter from '../../hooks/useRouter';
import { FORGOT_PASSWORD } from './graphql/Mutations';

const { required, email } = formValidatorRules;

const ForgotPassword = () => {
  const { navigate } = useRouter();
  const [forgotPassword, { loading }] = useMutation(FORGOT_PASSWORD, {
    onError() { },
  });
  const onFinish = async (values) => {
    forgotPassword({
      variables: values,
    }).catch((error) => {
      if (error && error.message) {
        message.error(error.message);
      } else {
        message.error('Something went wrong');
      }
    });
  };
  return (
    <div className="gx-login-container">
      <div className="login-logo">
        <LoginLogo width="200" height="60" />
      </div>
      <div className="gx-login-content">
        <div className="gx-mb-4">
          <h1>Forgot Password</h1>
          <p>Enter your e-mail address</p>
        </div>
        <Spin spinning={false}>
          <Form
            layout="vertical"
            onFinish={onFinish}
            className="gx-login-form gx-form-row0"
          >
            <Form.Item
              name="email"
              label="Email Address"
              rules={[required, email]}
            >
              <Space.Compact block>
                <Space.Addon>
                  <Email />
                </Space.Addon>
                <Input placeholder="Enter Email" maxLength={254} />
              </Space.Compact>
            </Form.Item>
            <div className="form-buttons d-flex">
              <Form.Item>
                <Button
                  className="cancel-button"
                  onClick={() => {
                    navigate(ROUTES.LOGIN);
                  }}
                >
                  Back
                </Button>
              </Form.Item>
              <Form.Item>
                <Button
                  className="save-button"
                  shape="round"
                  type="primary"
                  loading={loading}
                  htmlType="submit"
                >
                  Submit
                </Button>
              </Form.Item>
            </div>
          </Form>
        </Spin>
      </div>
    </div>
  );
};

export default ForgotPassword;
